import { Service } from '@genial/services';
import { ReportingEnumsTermsLegalEntityScenarioEnum } from '@genial/services/dist/models';
import { ErrorResponse } from '@genial/services/src';
import { useSetRecoilState } from 'recoil';

import { useDownloadFileWithScreenLock } from '../../hooks/useDownloadFileWithScreenLock';
import { useToastCreator } from '../../hooks/useToastCreator';

import { updateExportingFileNameDocumentsCenter } from './selector';

const fileNameNormalized: Record<string, string> = {
  manualAccountOpeningBrokerageBank: 'abertura_conta_manual_Banco_Corretora',
  manualAccountOpeningBank: 'abertura_conta_manual_Banco',
  manualAccountOpeningBrokerage: 'abertura_conta_manual_Corretora',
  digitalAccountOpeningBrokerageBank: 'abertura_conta_digital_Banco_Corretora',
};

export const useDocumentsCenterAction = () => {
  const { showToast } = useToastCreator('download-form-and-terms-toast');
  const { downloadFile } = useDownloadFileWithScreenLock();

  const setExportingFileNameDocumentsCenter = useSetRecoilState(
    updateExportingFileNameDocumentsCenter
  );

  const downloadMultipleDocumentsCenter = async (
    fileName: ReportingEnumsTermsLegalEntityScenarioEnum
  ) => {
    if (!fileName) {
      return;
    }

    setExportingFileNameDocumentsCenter(fileName);

    const handleDownloadError = (error?: ErrorResponse) => {
      showToast(
        'error',
        'Não foi possível processar sua solicitação.',
        error?.errorMessage || 'Erro ao baixar documentos solicitados.'
      );
    };

    try {
      const { data } = await Service.ReportingServices.V1.getReportingFormsTermsLegalEntity({
        scenario: fileName,
        screenName: 'DocumentsCenter',
      });

      if (!data || !data.preSignedUrl || data.preSignedUrl === '') {
        handleDownloadError();
        return;
      }

      await downloadFile(data.preSignedUrl, {
        fileName: `${fileNameNormalized[fileName] || 'central_documentos'}.zip`,
        mimeType: 'application/zip',
      });
    } catch (error) {
      handleDownloadError(error as ErrorResponse);
      throw error;
    } finally {
      setExportingFileNameDocumentsCenter('');
    }
  };

  return {
    downloadMultipleDocumentsCenter,
  };
};
